import { render, staticRenderFns } from "./presentationProductLottery.vue?vue&type=template&id=2f0f8722&"
import script from "./presentationProductLottery.vue?vue&type=script&lang=js&"
export * from "./presentationProductLottery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports